import {
  FinanceBudgetsDetailBudgetFragment,
  FinanceBudgetsBudgetAmountWidgetsFragment,
} from 'generated/resources/graphql'
import { Box } from '@factorialco/deprecated-design-system'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import { F0Alert } from '@factorialco/f0-react'

import { TrainingResourceDataCollection } from './TrainingResourceDataCollection'
import { amountWithCurrency } from 'modules/finance/lib/budgets'

interface Props {
  budget: FinanceBudgetsDetailBudgetFragment
  amounts: FinanceBudgetsBudgetAmountWidgetsFragment
}

export const BudgetDetailDataCollection = ({ budget, amounts }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()

  const showOverBudgetAlert =
    budget.currentStatus === 'over_budget' && amounts.budgetedAmountCents > 0
  const exceedAmount = showOverBudgetAlert
    ? amountWithCurrency(Math.abs(amounts.availableAmountCents), budget.currency, locale)
    : 0
  const exceedPercentage = showOverBudgetAlert
    ? (Math.abs(amounts.committedAmountCents) * 100) / amounts.budgetedAmountCents
    : 0

  return (
    <Box flexDirection="column" gap="s16">
      {showOverBudgetAlert && (
        <F0Alert
          description={i18n.t('budgets.overbudget_alert.description', {
            exceed_amount: exceedAmount,
            exceed_percentage: exceedPercentage.toFixed(2),
          })}
          title={i18n.t('budgets.overbudget_alert.title')}
          variant="critical"
        />
      )}
      {budget.budgetableBy === 'training_class' && (
        <TrainingResourceDataCollection locale={locale} budget={budget} amounts={amounts} />
      )}
    </Box>
  )
}
